export const freeProductPlacholder = {
  name: "Free",
  description: "Blumira's Free Edition connects up to three Cloud Connectors.",
  productId: null,
  priceId: null,
  listItems: [
    "Up to 3 Cloud Connectors",
    "Unlimited users and data ingestion",
    "1 week data retention",
    "Detections & response",
    "Basic reporting",
    "Summary dashboard",
  ],
};

export const productKeys = ["Microsoft 365", "Cloud", "Advanced"];

const freeSiemPlanJson = {
  name: "Free SIEM",
  licenseValue: "FREE",
  listItems: [
    "Choose up to 3 cloud integrations - Microsoft 365, Duo Security, Cisco Umbrella, Webroot, and/or Mimecast",
    "Unlimited users and data ingestion",
    "14 days of data retention",
    "Detections & response",
    "Basic reporting",
    "Summary dashboard",
    "Rule insights",
  ],
};

const siemProPlanJson = {
  name: "SIEM Pro",
  licenseValue: "SIEM_PRO",
  description: "Everything in Free SIEM and...",
  listItems: [
    "30 days retention",
    "All cloud & sensor integrations",
    "Detection rule insight & management",
    "Detection filters",
    "Advanced dashboards",
    "Advanced reporting",
    "Manual dynamic blocklists",
    "Notifications (voice, email & text)",
    "Customer Support (9am-8pm ET)",
  ],
};

const bluAgentProductBonus = {
  title: "Blumira Agent included",
  description:
    "Detect & respond to Windows endpoint threats - contain threats quickly with host isolation to prevent ransomware & breaches.",
};

const siemEndpointPlanJson = {
  name: "SIEM + Endpoint Visibility",
  licenseValue: "SIEM_ENDPOINT",
  description: "Everything in SIEM Pro and...",
  listItems: [
    "1 year retention",
    "1 Blumira Agent per license included, additional agents available",
    "Manual host isolation",
    "Emergency after hours support (24/7 for critical issues)",
    "Honeypots",
  ],
  bonusMaterial: bluAgentProductBonus,
};

const xdrPlatformPlanJson = {
  name: "XDR Platform",
  licenseValue: "XDR",
  description: "Everything in SIEM + Endpoint Visibility and...",
  listItems: [
    "1 year retention",
    "1 Blumira Agent per license included, additional agents available",
    "Manual + automated host isolation",
    "Automated blocking for dynamic blocklists",
  ],
  bonusMaterial: bluAgentProductBonus,
};

export const availablePlans = [
  freeSiemPlanJson,
  siemProPlanJson,
  siemEndpointPlanJson,
  xdrPlatformPlanJson,
];

// leaving the copy below around for the time being in case we end up needing it for legacy users

// export const microsoft365PlanJson = {
//   name: "Microsoft 365",
//   licenseValue: "M365",
//   description: "Access full support and longer data retention.",
//   listItems: [
//     "1 cloud integration - Microsoft 365",
//     "Unlimited data ingestion",
//     "30 days of data retention",
//     "Detections & response",
//     "Advanced reporting",
//     "Security dashboards",
//     "Detection rule management",
//     "24/7 security operations team support",
//   ],
// };

// export const cloudPlanJson = {
//   name: "Cloud",
//   licenseValue: "CLOUD",
//   description: "Expand to cover popular cloud applications.",
//   listItems: [
//     "Access to all cloud integrations",
//     "Unlimited data ingestion",
//     "1 year of data retention",
//     "Detections & response",
//     "Advanced reporting",
//     "Security dashboards",
//     "Detection rule management",
//     "24/7 security operations team support",
//   ],
// };

// export const advancedPlanJson = {
//   name: "Advanced",
//   licenseValue: "ADVANCED",
//   description: "Full coverage across your entire environment.",
//   listItems: [
//     "Coverage for all on-premises and cloud integrations",
//     "Unlimited data ingestion",
//     "1 year of data retention",
//     "Detections & response",
//     "Advanced reporting",
//     "Security dashboards",
//     "Automated response (dynamic blocklists)",
//     "Detection rule management",
//     "Detection filters",
//     "Honepots",
//     "24/7 security operations team support",
//   ],
// };
